/*
 * Copyright (c) 2019 brightlamp
 */

import Vue from 'vue'
import Vuex from 'vuex'
import auth from './auth'
import common from './common'
import customerBilling from './customer-billing'
import exportResult from './export-result'
import mrns from './mrns'
import orgs from './orgs'
import messages from './messages'
import sendMessage from './send-message'
import telehealth from './telehealth'
import tests from './tests'
import users from './users'

Vue.use(Vuex);

export const store = new Vuex.Store(
{
    state: {},
    getters: {},
    mutations: {},
    actions: {},
    modules:
    {
        auth,
        common,
        customerBilling,
        exportResult,
        messages,
        mrns,
        orgs,
        sendMessage,
        telehealth,
        tests,
        users
    }
});